import React from "react";
import { formatDateTime } from "../common-data/Converts";

const WTF360ConsultationDetail = ({
  userInfoData,
  rowData,
  closeModal,
  callFunction,
}) => {
  const getStatusBadge = (status) => {
    const statusMap = {
      pending: {
        label: "Pending",
        className: "wtf-360-consultation-detail-status-badge-pending",
      },
      contacted: {
        label: "Contacted",
        className: "wtf-360-consultation-detail-status-badge-contacted",
      },
      scheduled: {
        label: "Scheduled",
        className: "wtf-360-consultation-detail-status-badge-scheduled",
      },
      completed: {
        label: "Completed",
        className: "wtf-360-consultation-detail-status-badge-completed",
      },
      cancelled: {
        label: "Cancelled",
        className: "wtf-360-consultation-detail-status-badge-cancelled",
      },
    };

    const statusInfo = statusMap[status] || {
      label: status || "Unknown",
      className: "wtf-360-consultation-detail-status-badge-default",
    };

    return (
      <span
        className={`wtf-360-consultation-detail-status-badge ${statusInfo.className}`}
      >
        {statusInfo.label}
      </span>
    );
  };

  const getPrimaryGoalLabel = (goal) => {
    const goalMap = {
      weight_loss: "Weight Loss",
      muscle_gain: "Muscle Gain",
      fitness: "Fitness",
      health: "Health",
      other: "Other",
    };

    return goalMap[goal] || goal || "Not Specified";
  };

  return (
    <div className="wtf-360-consultation-detail-container mt30">
      <div className="wtf-360-consultation-detail-section">
        <h3 className="wtf-360-consultation-detail-section-title">
          Customer Information
        </h3>
        <div className="wtf-360-consultation-detail-grid">
          <div className="wtf-360-consultation-detail-field">
            <label className="wtf-360-consultation-detail-label">Full Name:</label>
            <span className="wtf-360-consultation-detail-value">
              {rowData?.full_name || "N/A"}
            </span>
          </div>

          <div className="wtf-360-consultation-detail-field">
            <label className="wtf-360-consultation-detail-label">
              Phone Number:
            </label>
            <span className="wtf-360-consultation-detail-value">
              {rowData?.phone_number || "N/A"}
            </span>
          </div>

          <div className="wtf-360-consultation-detail-field">
            <label className="wtf-360-consultation-detail-label">Email:</label>
            <span className="wtf-360-consultation-detail-value">
              {rowData?.email || "N/A"}
            </span>
          </div>

          <div className="wtf-360-consultation-detail-field">
            <label className="wtf-360-consultation-detail-label">UID:</label>
            <span className="wtf-360-consultation-detail-value">
              {rowData?.uid || "Not Assigned"}
            </span>
          </div>
        </div>
      </div>

      <div className="wtf-360-consultation-detail-section">
        <h3 className="wtf-360-consultation-detail-section-title">
          Consultation Details
        </h3>
        <div className="wtf-360-consultation-detail-grid">
          <div className="wtf-360-consultation-detail-field">
            <label className="wtf-360-consultation-detail-label">
              Primary Goal:
            </label>
            <span className="wtf-360-consultation-detail-value">
              {getPrimaryGoalLabel(rowData?.primary_goal)}
            </span>
          </div>

          <div className="wtf-360-consultation-detail-field">
            <label className="wtf-360-consultation-detail-label">
              Preferred City:
            </label>
            <span className="wtf-360-consultation-detail-value">
              {rowData?.preferred_city
                ? rowData.preferred_city.charAt(0).toUpperCase() +
                  rowData.preferred_city.slice(1)
                : "Not Specified"}
            </span>
          </div>

          <div className="wtf-360-consultation-detail-field">
            <label className="wtf-360-consultation-detail-label">Status:</label>
            <span className="wtf-360-consultation-detail-value">
              {getStatusBadge(rowData?.status)}
            </span>
          </div>
        </div>
      </div>

      <div className="wtf-360-consultation-detail-section">
        <h3 className="wtf-360-consultation-detail-section-title">Notes</h3>
        <div className="wtf-360-consultation-detail-notes-box">
          <p className="wtf-360-consultation-detail-notes-text">
            {rowData?.notes || "No notes available"}
          </p>
        </div>
      </div>

      <div className="wtf-360-consultation-detail-section">
        <h3 className="wtf-360-consultation-detail-section-title">Timeline</h3>
        <div className="wtf-360-consultation-detail-grid">
          <div className="wtf-360-consultation-detail-field">
            <label className="wtf-360-consultation-detail-label">Created At:</label>
            <span className="wtf-360-consultation-detail-value">
              {rowData?.created_at ? formatDateTime(rowData.created_at) : "N/A"}
            </span>
          </div>

          <div className="wtf-360-consultation-detail-field">
            <label className="wtf-360-consultation-detail-label">
              Last Updated:
            </label>
            <span className="wtf-360-consultation-detail-value">
              {rowData?.updated_at ? formatDateTime(rowData.updated_at) : "N/A"}
            </span>
          </div>
        </div>
      </div>

      <div className="wtf-360-consultation-detail-actions">
        <button
          className="wtf-360-consultation-detail-action-btn wtf-360-consultation-detail-action-btn-close"
          onClick={closeModal}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default WTF360ConsultationDetail;
